import React, { useEffect, useState, useCallback } from 'react';
import { MdCircle } from 'react-icons/md';
import { getNotesPage } from '../../utils/api/notes';
import { useToasts } from '../../hooks';
import { getPriorityColor } from '../../utils/api/site';
import { formatNumericDate } from '../../utils/dates';
import { capitalizeFirstLetter } from '../../utils/api';
import { formatPriority } from '../../utils/formatPriority';

const useFetchNotes = (organizationId, params, currentPage, itemsPerPage, setTotalNotes, setTotalUnfilteredNotes = () => {}, isNoteModalsOpen) => {
  const [notes, setNotes] = useState([]);
  const { showToast } = useToasts();
  const fetchNotes = useCallback(async () => {
    try {
      const response = await getNotesPage(organizationId, { ...params, page: currentPage, perPage: itemsPerPage });
      const data = await response.json();
      if (!data.notes) {
        throw new Error(data.error);
      }

      const newData = data.notes.map(note => (
        {
          ...note,
          status: capitalizeFirstLetter(note.status),
          priority: (
            <div className="flex space-x-2 items-center">
              <MdCircle size={16} color={getPriorityColor(note?.priority)} />
              <p>{formatPriority(note.priority)}</p>
            </div>
          ),
          priorityCardColor: note.priority,
          timestamp: formatNumericDate(note.timestamp),
        }
      ));
      setNotes(newData);
      // Check if there are active search parameters (any non-empty values in search fields)
      const isSearchActive = !!params.site_name || !!params.note_content_title || !!params.status;
      // Set totalNotes based on search state
      setTotalNotes(isSearchActive ? data.result_count : data.total_count);
      setTotalUnfilteredNotes(data.total_count);
    } catch (error) {
      showToast({
        message: `Failed to fetch notes: ${error.message}`,
        type: 'error',
      });
    }
  }, [organizationId, params, currentPage, itemsPerPage, setTotalNotes, setTotalUnfilteredNotes, showToast]);

  // we need to use function fetchNotes() separately after delete and update note
  useEffect(() => {
    if (isNoteModalsOpen) return;
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, currentPage, itemsPerPage, isNoteModalsOpen]);
  return [notes, fetchNotes];
};

export default useFetchNotes;
